var uAjax = "/index.cfm/transaction/ajax";
$(function()
{
	// Hide webcode field on load
	$(el('edtWebCode')).closest('.control-group').hide();

	// show popup for finalize error
  	if(bStockError === true)
 	{
		showAlert('error', sStockErrorMessage, false);
  	}

	if(sTransactionIndexErrorMessage !== "")
 	{
		showAlert('error', sTransactionIndexErrorMessage, false);
  	}

  	var oBasket = $(el('mainContainer'));
	// change quantity listeners
	oBasket.on('click', '.qtyMin', function()
	{
		changeQty($(this).next(), 'min');
		return false;
	});
	oBasket.on('click', '.qtyPlus', function()
	{
		changeQty($(this).prev(), 'plus');
		return false;
	});
	oBasket.on('change', '.edtQty', function()
	{
		var iQty = $(this).val();
		var iMultiplier = $(this).data('multiplier');
		var iStock = parseInt($(this).data('stock'));
		var sLineId = $(this).attr("line-id");

		if(iQty == 0){
			removeLine(sLineId);
		}
		else
		{
			validateQty(iQty,iMultiplier,iStock,sLineId);
		}
	});
	oBasket.on('click', '.btnRefresh', function()
	{
		var iQty = $(this).closest('tr').find('.edtQty').val();
		var iMultiplier = $(this).closest('tr').find('.edtQty').data('multiplier');
		var iStock = parseInt($(this).closest('tr').find('.edtQty').data('stock'));
		var sLineId = $(this).attr("line-id");

		validateQty(iQty,iMultiplier,iStock,sLineId);
	});

	// remove transaction line listener
	oBasket.on('click', '.btnRemove', function()
	{
		askRemoveLine($(this).attr("line-id"));
	});

	oBasket.on('click', '#removeLine', function()
	{
		removeLine($(this).attr("line-id"));
	});

	// cancel full transaction
	oBasket.on('click', '#cancelFullOrderBtnId', function()
	{
		$('#cancelOrderModal').modal('toggle');
	});

	// giftvoucher form listener
	oBasket.on('click', '#addGiftVoucher', function()
	{
		var sInputValue = $(el('edtVoucher')).val();
		var sInputWebCodeValue = $(el('edtWebCode')).val();
		var bWebcodeAlwaysVisible = ($('.webcodeAlwaysVisible').length > 0);
		sInputValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputValue.trim().replaceAll(" ","") : sInputValue;
		sInputWebCodeValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputWebCodeValue.trim().replaceAll(" ","") : sInputWebCodeValue;
		if($('#edtWebCode').is(":visible") && !bWebcodeAlwaysVisible)
		{
			if(fieldIsValid($('#edtWebCode')))
			{
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
			else
			{
				setFieldValidationState($('#edtWebCode'),'error');
			}
		}
		else
		{
			if(bWebcodeAlwaysVisible) {
				if (sInputWebCodeValue == '' && sInputValue == '') {
					setFieldValidationState($('#edtVoucher'),'error');
				} else if ($('.webcodeAlwaysVisible').prop('required') && sInputWebCodeValue == '') {
					setFieldValidationState($('#edtVoucher'),'success');
					setFieldValidationState($('#edtWebCode'),'error');
				} else {
					submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
				}
			} else {
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
		}

		return false;
	});

	// promo form listener
	oBasket.on('click', '#addPromoCode', function()
	{
		submitGiftVoucher($(el('edtPromoCode')).val().toUpperCase(),'');

		return false;
	});

	// remove giftvoucher listener
	oBasket.on('click', '.icon-remove', function()
	{
		if($(this).hasClass('promoCode')){
			removePromoCode($(this).data('promocodeId'));
		}
		else
		{
			removeGiftVoucher($(this).data('paymentId'));
		}
		return false;
	});

	preventNegativeValue();

	$('.input-quantity').keyup(function()
	{
		makePositiveValue($(this));
	});

	oBasket.on('click', '.campainLink', function() {
		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		addFeaturedProduct(sSku, 1, sShopId, sCollectMethod);
		return false;
	});

	// Add product to basket (home delivery)
	oBasket.on('click','.checkoutCampaignPopupAddSku', function(e)
	{
		e.preventDefault();

		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		addFeaturedProduct(sSku, 1, sShopId, sCollectMethod);
		return false;
	});

	oBasket.on('click','.checkoutCampaignPopupAddConfiguration', function(e)
	{
		e.preventDefault();

		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		var sWebname       = $(this).data('webname');

		if(sSku)
		{
			var oSelectedSku = {};
			oSelectedSku.description = sWebname;
			oSelectedSku.quantity    = 1;
			oSelectedSku.skuId       = sSku;

			var addons = getSelectedAddons();
			addons.push(oSelectedSku);

			sAddons = JSON.stringify(addons);
			addFeaturedConfiguration(oSelectedSku.skuId,oSelectedSku.quantity,sShopId,sCollectMethod,sAddons);
		}
		return false;
	});

	oBasket.on('click', '.qtyBtn', function(e) {
		e.preventDefault();

		var oEdtQty    = $(this).parents('.priceData').find('.edtQty');

		var iCurrentVal = parseInt(oEdtQty.val());
		var iMultiplier = parseInt(oEdtQty.data('qtyMultiplier'));
		var sType      = $(this).attr('data-type');

		if (!isNaN(iCurrentVal))
		{
			if(sType === 'minus')
			{
				if(iCurrentVal > oEdtQty.attr('min'))
				{
					oEdtQty.val(iCurrentVal - (1*iMultiplier)).change();
				}
			}
			else if(sType === 'plus')
			{
				oEdtQty.val(iCurrentVal + (1*iMultiplier)).change();
			}
		}
	});

	oBasket.on('click', '.btnToCheckout,.offsetFreeDelivery', function(e) {
		e.preventDefault();

		if($(el('offsetForFreeDeliveryModal')).length)
		{
			promptOffsetForFreeDeliveryModal()
		}
		else
		{
			window.location = this.href;
		}
	});

	oBasket.on('hide', '#offsetForFreeDeliveryModal', function()
	{
		window.location = $('.btnToCheckout').attr('href');
	});

	if($(window).width() < 768)
	{
		$(el('offsetForFreeDeliveryModal')).one('shown', function()
		{
			$('.featuredproducts .flexslider').each(function(index){
				$(this).flexslider({
					animation: "slide",
					animationLoop: false,
					controlNav: false,
					itemMargin: 0,
					slideshow: false,
					touch: true
				});
			});
			centerPopups();
		});
	}

	oBasket.on('change keyup', '#edtVoucher', function(e)
	{
		var sInput = $(el('edtVoucher')).val().toLowerCase().replace(/\s/g,'');
		if(sInput.length > 1)
		{
			// Check if code starts with voucher prething
			var aListVoucher = ["gft","loy","cv","vrn","0000"];
			matched = false;
			for(i=0; i<= aListVoucher.length; i++)
			{
				if(sTenantId === 175 && (sInput === "0000000000215" || sInput === "0000000000284"))
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
				else if(sInput.indexOf(aListVoucher[i]) == 0)
				{
					$(el('edtWebCode')).closest('.control-group').show();
					$('.webcodeAlwaysVisible').prop('required', true);
					matched = true;
					break;
				} else {
					$('.webcodeAlwaysVisible').prop('required', false);
				}
			}
			if(!matched)
			{
				// Check years
				if(sInput.length > 3)
				{
					var checkYear = parseInt(sInput.substring(0,4));
					if(!isNaN(parseFloat(checkYear)) && isFinite(checkYear))
					{
						if(checkYear > 2000 && checkYear < 3000)
						{
							// it is a year
							$(el('edtWebCode')).closest('.control-group').show();
						}
					}
					else
					{
						$(el('edtWebCode')).closest('.control-group').hide();
					}
				}
				else
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
			}
		}
		else
		{
			$(el('edtWebCode')).closest('.control-group').hide();
		}
	});

	// add mwise customer voucher
	oBasket.on("change", ".inputCustomerVouchers", function(e)
	{
		if($(this).is(":checked"))
		{
			addCustomerVoucher($(this));
		}
	});

	oBasket.on("click", ".entryPreview", function(e)
	{
		var oEntryPreviewBtn = $(this);
		if(oEntryPreviewBtn.hasClass('loaded'))
		{
			oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages a").first().trigger("click");
		}
		else
		{
			oEntryPreviewBtn.addClass("loading");
			sEntryId = oEntryPreviewBtn.data('entryId');

			oCall = entryPreview(sEntryId);
			oCall.success(function(oData)
			{
				oEntryPreviewBtn.removeClass("loading");

				if(oData.errorMessage == "" && typeof oData.entry !== "undefined" && typeof oData.entry.result !== "undefined" && oData.entry.result.length > 0)
				{
					oEntryPreviewBtn.addClass('loaded');
					$.each(oData.entry.result, function( index, value ) {
						oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages").append('<a href="' + value + '" data-fancybox="' + sEntryId + '"></a>');
					});
					oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages a").first().trigger("click");
				}
				else
				{
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	oBasket.on('keypress','.edtCeraNumber', function(e)
	{
		if (e.keyCode == 13)
		{
			e.preventDefault();

			saveCeraNumbers($(el("ceraForm")));
		}
	});

	oBasket.on('blur','.edtCeraNumber', function(e)
	{
		e.preventDefault();
		saveCeraNumbers($(el("ceraForm")));
	});

	init();
	if(bEnableCalcDeliveryPromise) calcDeliveryPromise();
});

function saveCeraNumbers(oFrm)
{
	var sParams = getValues(oFrm);
	var oCall = callAjax("saveCeraNumbers", sParams, "post","/index.cfm/transaction/ajax/saveCeraNumbers");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			// Add to basket successful
			location.reload(true);
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function addCustomerVoucher(oInput)
{
	var sCode        = oInput.val();
	var sDescription = oInput.data('description');
	var sVoucherRun  = oInput.data('voucherRun');

	var sParams = '&code=' + sCode + '&runId=' + sVoucherRun + '&description=' + sDescription;
	var oCall = callAjax("addCustomerVoucher", sParams, "post");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			// Add to basket successful
			location.reload(true);
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function addFeaturedConfiguration(sSku, iQty, sShopId, sCollectMethod,sAddons)
{
	// Set loader
	var sParams = '&mainSkuId=' + sSku
				+ '&mainSkuQty=' + iQty
				+ '&shopId=' + sShopId
				+ '&collectMethodId=' + sCollectMethod
				+ '&addons=' + encodeURIComponent(sAddons);
	var oCall = callAjax("addConfiguration", sParams, "post");
	// process feedback
	oCall.success(function(oData)
	{
		$('.checkoutCampaignPopup').modal('hide');

		if(oData.errorType == '')
		{
			// Add to basket successful
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function addFeaturedProduct(sSku, iQty, sShopId, sCollectMethod)
{
	// Set loader
	var sParams = '&skuId=' + sSku
				+ '&qty=' + iQty
				+ '&idShop=' + sShopId
				+ '&collectMethodId=' + sCollectMethod
				+ '&customHtml=index';
	var oCall = callAjax("addSku", sParams, "post");
	// process feedback
	oCall.success(function(oData)
	{
		$('.checkoutCampaignPopup').modal('hide');

		if(oData.errorType == '')
		{
			// Add to basket successful
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function askRemoveLine(sLineId)
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'removeLine', {'line-id': sLineId});
	setPopupHeader(oPopup, sAskRemoveLineTitle, '');
	oPopup.find('.modal-body .content').html(sAskRemoveLineContent);

	oPopup.find('.modal-footer .action').html(sAskRemoveLineConfirm);
	oPopup.find('.modal-footer .cancel').html(sAskRemoveLineCancel);

	oPopup.modal();
}

function calcDeliveryPromise()
{
	clearErrors();

	// AJAX call
	var oCall   = callAjax("calcDeliveryPromise", "", "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$(el('mainContent')).html(oData.html);

			$(el('edtWebCode')).closest('.control-group').hide();

			// refresh basket dropdown
			getBasketDropdownHeader();

			init();
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function changeLineQty(sLineId, iQty)
{
	clearErrors();

	var buttons = $('[line-id=' + sLineId + ']').parent().find('.qtyBtn');
	buttons.each(function(){
		$(this).prop('disabled', true);
	});

	// AJAX call
	var sParams = '&lineId=' + sLineId + '&lineQty=' + iQty;
	var oCall   = callAjax("changeLineQty", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$(el('mainContent')).html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();

			if($('[line-id=' + sLineId + ']').parents('.line-wrapper').length > 0)
			{
				inlineAlert('warning', tQuantityChanged, false, $('[line-id=' + sLineId + ']').parents('.line-wrapper'),false);
			}
			else
			{
				showAlert('warning', tQuantityChanged, false, '1000');
			}

			// refresh basket dropdown
			getBasketDropdownHeader();

			init();
		}
		else if(oData.errorType === 'EMaximumOrderQuantityReached')
		{
			var iMaxOrderQuantity = $('[line-id=' + sLineId + ']').data("max-order-quantity");
			if(typeof iMaxOrderQuantity != "undefined") $('[line-id=' + sLineId + ']').val(iMaxOrderQuantity);

			if($('[line-id=' + sLineId + ']').parents('.line-wrapper').length > 0)
			{
				inlineAlert('error', oData.errorMessage, false, $('[line-id=' + sLineId + ']').parents('.line-wrapper'),false);
			}
			else
			{
				showAlert('error', oData.errorMessage, false, '1000');
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);

		buttons.each(function(){
			$(this).prop('disabled', false);
		});
	});
}

function changeQty(edtQty, type)
{
	if (type == 'plus') {
		if (edtQty.prop('value') < 9999) {
			edtQty.prop('value', parseInt(edtQty.prop('value')) + 1);
		}
	} else {
		if (edtQty.prop('value') > 1) {
			edtQty.prop('value', parseInt(edtQty.prop('value')) - 1);
		}
	}

	$(edtQty).trigger('change');
}

function disableQtyEdit()
{
	var arraySerialRequiredLines = JSON.parse(aSerialRequiredLines)
	$(arraySerialRequiredLines).each(function(i,el)
	{
		var oInput = $('.edtQty[line-id*=' + el + ']');
		oInput.prop('disabled', true);
		oInput.parents('.input-prepend.input-append').find('.qtyBtn').prop('disabled', true);
	});
}

function entryPreview(sEntryId)
{
	var sParams = '&entryId=' + sEntryId;

	return callAjax("entrypreview", sParams, "post", "/index.cfm/product/ajax/entrypreview");
}

function init()
{
	disableQtyEdit();
	initLazyResponsiveLoad();
	if (typeof initFlexSliders === "function") initFlexSliders();
	if (typeof initFeaturedProducts === "function") initFeaturedProducts();
	if (typeof initFeaturedProductsGridSlider === "function") initFeaturedProductsGridSlider();
	if (typeof initForms === "function") initForms();
	if (typeof initContentEventHandlers === "function") initContentEventHandlers();
	if (typeof initHotSpotImages === "function") initHotSpotImages();
	if (typeof initPaymentOptions === "function") initPaymentOptions();
	ciResponsive.process();
}

function preventNegativeValue()
{
	var quantityField = $(".input-quantity");

	quantityField.keypress(function(event)
	{
		if ( event.which == 45 ) {
			event.preventDefault();
		}
	});

}
function makePositiveValue(element)
{
	var quantityFieldValue = element.val();
	var positiveValue = Math.abs(quantityFieldValue);
	element.val(positiveValue);
}

function promptOffsetForFreeDeliveryModal()
{
	$(el('offsetForFreeDeliveryModal')).modal('show');
}

function removeGiftVoucher(sPaymentId)
{
	var sParams = '&paymentId=' + sPaymentId;
	var oCall   = callAjax("removePayment", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			location.reload(true);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function removeLine(lineId) {
	var sParams = '&lineId=' + lineId;
	var oCall = callAjax("deleteLine", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType == '')
		{
			$('#popupContinue').modal('hide');
			showAlert('warning', tLineRemoved, false, 4000);
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			getBasketDropdownHeader();

			init();

			$(document).trigger( "removeLine",[lineId]);
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);
	});
}

function removePromoCode(sPromoCodeId)
{
	var sParams = '&promoCodeId=' + sPromoCodeId;
	var oCall   = callAjax("removePromoCode", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			location.reload(true);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});

}

function submitGiftVoucher(sGiftVoucher, sWebCode)
{
	if($.trim(sWebCode) === '')
	{
		sWebCode = '000';
	}
	var sParams = '&giftvoucher=' + encodeURIComponent(sGiftVoucher) + '&webcode=' + sWebCode;

	var oCall   = callAjax("addGiftVoucher", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			location.reload(true);
		}
		else
		{
			if(oData.errorType === 'EVoucherInvalidWebcode')
			{
				showAlert('error', tInvalidWebcode, oData.errorUnhandled,3000);
			}
			else if(oData.errorType === 'EVoucherCannotBeValidatedWithoutWebCode')
			{
				showAlert('error', tEmptyWebcode, oData.errorUnhandled,3000);
			}
			else {
				showAlert('error', oData.errorMessage, oData.errorUnhandled,3000);
			}
		}
	});
}

function validateQty(iQty,iMultiplier,iStock,sLineId)
{
	if(isNaN(iQty) !== true && iQty != ""){

		iQty = Math.abs(iQty);
		iQty = (iMultiplier > 1 ? iQty*iMultiplier : iQty);
		iQty = (iStock < iQty && iStock > 0 ? iStock : iQty);

		changeLineQty(sLineId, iQty);
	}
}